import React from "react";
import "./FooterSection.css";
import useReveal from "../../hooks/useReveal"; // adjust path if needed


const FooterSection = () => {

    const badgeRef = useReveal();
    const headingRef = useReveal();
    const buttonRef = useReveal();
    const bottomRef = useReveal();


  return (
    <footer className="footer-wrapper">
      {/* BLACK RECTANGLE (MASK) */}
      <div className="footer-mask" aria-hidden="true" />

      {/* FOOTER CONTENT */}
      <div className="footer-content">
        {/* Available for opportunities */}
            <div
              className="tw-header footer-badge reveal"
              ref={badgeRef}
            >
          <div className="Star">
            <img src="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091837/Star_1_vvtjst.png" alt="Star" className="Star-img" />
          </div>
          <div className="twh-text">Available For Opportunities</div>
        </div>

        {/* Main text */}
        <div className="footer-center">
        <h2 className="footer-heading reveal" ref={headingRef} >
          Let’s make those <br /> imaginations into reality. <br />
          Giving you the best.
        </h2>

        <a href="https://wa.link/q7egxz">
        <button className="footer-btn reveal" ref={buttonRef} >Contact Me Now</button>
        </a>
        </div>
        <div className="footer-divider" />

        {/* Bottom */}
        <div className="footer-bottom reveal" ref={bottomRef}>
        <img src="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091840/RemzyArts-logo_dprqf0.svg" alt="RemzyArts" className="footer-logo" />

        <div className="footer-socials">
        <a href="https://www.instagram.com/remzy.arts?igsh=OTZxb3JpcDkyeWt0" className="social-icon instagram">
            <img src="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091829/Instagram_xi209h.svg" alt="Instagram" />
        </a>

        <a href="https://www.linkedin.com/in/rhema-marcus-0256bb397" className="social-icon linkedin">
            <img src="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091830/Linkedin_v9ru9u.svg" alt="LinkedIn" />
        </a>

        <a href="https://www.threads.com/@remzy.arts" className="social-icon threads">
            <img src="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091841/Thread_i1stc3.svg" alt="Threads" />
        </a>

        <a href="https://x.com/only1techbro" className="social-icon twitter">
            <img src="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091846/X_fpuugh.svg" alt="X" />
        </a>

        <a href="https://www.facebook.com/share/1HEcjgBHix/" className="social-icon facebook">
            <img src="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091829/Facebook_orlclj.svg" alt="Facebook" />
        </a>

        <a href="https://www.tiktok.com/@remzy.arts?_r=1&_t=ZS-937zAM0CdIl" className="social-icon tiktok">
            <img src="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091845/Tiktok_thybua.svg" alt="TikTok" />
        </a>

        <a href="https://wa.link/q7egxz" className="social-icon whatsapp">
            <img src="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091830/Whatsapp_zfntge.svg" alt="WhatsApp" />
        </a>
        </div>


        <p className="footer-copy">
            ©2026 RemzyArts. All Rights Reserved.
        </p>
        </div>

      </div>
    </footer>
  );
};

export default FooterSection;
